<app-top-navigation backLinkPath="/">
  <span title>Importar colaboradores</span>
</app-top-navigation>
<div class="file-upload-container">
  <up-feature-upload-import-files (childEmitter)="cancelImport()" [customItem]="collaborator"></up-feature-upload-import-files>
</div>
